import type { ApiResponse } from 'shared/api/responses';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { api } from 'shared/api/client';

export type Linkrole = NonNullable<AiPrediction['linkroles']>[number];

export type AiPrediction = AiCellSuggestion['predictions'][number];

export type AiCellSuggestion = TableSuggestions['suggestions'][number];

export type TableSuggestions = ApiResponse<'/ai-tagging/table/{referenceDataSuperId}', 'post'>;

export interface SuggestTableTagsInput {
  referenceDataSuperId: string;
  documentSuperId: number;
  cells: { row: number; col: number }[];
  title?: string;
}

export function useSuggestTableTags(): UseMutationResult<TableSuggestions, Error, SuggestTableTagsInput> {
  return useMutation({
    mutationFn: async ({ referenceDataSuperId, documentSuperId, cells, title }: SuggestTableTagsInput) => {
      const res = await api.POST('/ai-tagging/table/{referenceDataSuperId}', {
        params: { path: { referenceDataSuperId } },
        body: { documentSuperId, cells, ...(title ? { title } : {}) },
      });
      return res?.data as TableSuggestions;
    },
  });
}
